import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
} from "@mui/material";
import { ENTITY_TYPE_OPTIONS } from "../models/enums/EntityTypeOptions";
import { EntityType } from "../models/enums/EntityType";

interface EntityTypeFilterSelectProps
  extends Omit<SelectProps<EntityType | "all">, "value" | "onChange"> {
  value: EntityType | "all";
  onChange: (value: EntityType | "all") => void;
  label?: string;
  includeAllOption?: boolean;
}

const EntityTypeFilterSelect: React.FC<EntityTypeFilterSelectProps> = ({
  value,
  onChange,
  label = "Filter by Entity Type",
  includeAllOption = true,
  ...rest
}) => {
  const handleChange = (event: SelectChangeEvent<EntityType | "all">) => {
    onChange(event.target.value as EntityType | "all");
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="entity-type-label">{label}</InputLabel>
      <Select<EntityType | "all">
        labelId="entity-type-label"
        value={value}
        label={label}
        onChange={handleChange}
        variant="outlined"
        {...rest}
      >
        {includeAllOption && <MenuItem value="all">All</MenuItem>}
        {ENTITY_TYPE_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EntityTypeFilterSelect;
